import { Component, Input, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';

@Component({
    selector:'ui-date-input',
  styleUrls: ["./ui-styles.css"],
  template: `<mat-form-field *ngIf="currentQuestion?.dataTypeName == 'date'">
    <input
      matInput
      [matDatepicker]="picker"
      (focus)="picker.open()"
      [max]="maxDate"
      [min]="minDate"
      placeholder="Pick Date"
      [(ngModel)]="currentQuestion.answerText"
    />
    <mat-datepicker-toggle
      matSuffix
      [for]="picker"
    ></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>`
})

export class DateInputComponent implements OnInit {
  @Input() currentQuestion: any;
  @Input() maxDate: any;
  @Input() minDate: any;

    constructor() { }

  ngOnInit() {
    if (this.currentQuestion.validations=='MaxDateToday' ) {
      this.maxDate = new Date();
      this.minDate = new Date(1900, 1, 1);
    }
    if (this.currentQuestion.validations=='MinDateToday') {
      this.maxDate = new Date(2050, 1, 1);
      this.minDate = new Date();
    }
  }
}
